/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA
 *
 */

/**
 * @typedef UserConfig
 */

/**
 * @type {UserConfig}
 */
export const DEFAULT_USER_CONFIG = {
    isSuggestedScoringEnabled: true,
    isMarkAsSuspiciousForCheatingEnabled: false,
    is_item_review_marking_symbols_enabled: false,
    is_item_review_highlighter_enabled: false,
    isCertificationProduct: false
};

/**
 * Set users config
 * @param {UserConfig} userConfiguration
 */
export const setConfig = userConfiguration => {
    const config = Object.assign({}, DEFAULT_USER_CONFIG, userConfiguration);
    window.localStorage.setItem('userConfiguration', JSON.stringify(config));
};

/**
 * Provides users config
 * @returns {UserConfig} userConfiguration
 */
export const getConfig = () => {
    const config = JSON.parse(window.localStorage.getItem('userConfiguration'));
    return Object.assign({}, DEFAULT_USER_CONFIG, config);
};
